import { Route, Routes } from "react-router-dom";
import Admin from "./pages/admin/adminpage";
import Home from "./pages/home/home";
import Menu from "./components/Menu";
import Footer from "./components/Footer";
import "./styles.css";
import { RequireAuth } from "./auth/requireAuth";
import LoginPage from "./pages/login/login";
import RegisterUser from "./pages/register/registerpage";
import UserSettings from "./pages/settings/settingspage";
import '@fortawesome/fontawesome-free/css/all.min.css';
import VerificationPage from "./pages/verification/verificationpage";
import RecruiterReviewPage from "./pages/recruiterReview/recruiterreviewpage";
import CandidateComparisonPage from "./pages/candidateComparison/candidatecomparisonpage";
import AddJobPostingPage from "./pages/jobPostings/addjobpostingpage";
import RecruiterWorkspacePage from "./pages/recruiterWorkspace/recruiterworkspacepage";

const App = () => {
  return (
    <div>
      <Menu />
      <Routes>
        <Route path='/' element={<Home />}></Route>
        <Route path='/login' element={<LoginPage />}></Route>
        <Route path='/register' element={<RegisterUser />}></Route>
        <Route path='/settings' element={<UserSettings />}></Route>
        <Route path='/verification' element={<VerificationPage />}></Route>
        <Route path='/register' element={<RegisterUser/>}></Route>
        <Route path='/adminpage' element={
          <RequireAuth role="admin">
            <Admin />
          </RequireAuth>
        }></Route>
        <Route path='/recruiterreview' element={
          <RequireAuth>
            <RecruiterReviewPage />
          </RequireAuth>
        }></Route>
        <Route path='/candidatecomparison' element={
          <RequireAuth>
            <CandidateComparisonPage />
          </RequireAuth>
        }></Route>
        <Route path='/jobpostings/new' element={
          <RequireAuth>
            <AddJobPostingPage />
          </RequireAuth>
        }></Route>
        <Route path='/recruiterworkspace' element={
          <RequireAuth>
            <RecruiterWorkspacePage />
          </RequireAuth>
        }></Route>
      </Routes>
      <Footer />
    </div>
  )
}

export default App;
